import React from 'react';
import { useHistory } from 'react-router-dom';

export default function BreadCrumbs({ breadCrumbs }) {
  const history = useHistory();

  if (!breadCrumbs) return null;

  const handleNavigation = () => {
    
    if (breadCrumbs.url) {
      history.push(breadCrumbs.url);
    } else if (history.length <= 1) {
      history.push('/');
    } else {
      history.goBack();
    }
  };

  const linkText = breadCrumbs.name || (history.length <= 1 ? 'На головну' : 'Назад');

  return (
    <div className="breadcrumbs-wrapper">
      <div className={`breadcrumbs-item${breadCrumbs.className ? ` ${breadCrumbs.className}` : ''}`}>
        <span
          className="breadcrumbs-link"
          onClick={handleNavigation}
        >
          <i className="fas fa-chevron-left" />
          {linkText}
        </span>
      </div>
    </div>
  );
}
